import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppNavbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import AllOrders from './components/AllOrders';
import OrderDetails from './components/OrderDetails';
import CommissionTracker from './components/CommissionTracker';
import SalesData from './components/SalesData';



function App() {
  return (
    <Router>
      <div className="App">
        <AppNavbar />
        <div className="container mt-4">
          <Routes>
            <Route path="/sales" element={<SalesData />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/orders" element={<AllOrders />} />
            <Route path="/order/:id" element={<OrderDetails />} />
            <Route path="/commission" element={<CommissionTracker />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
